import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect } from 'react';
import { useGrid } from '../hooks/useGrid';
const ThemeContext = createContext({});
export const GridProvider = ({ children }) => {
    const { gridColumns, gridGutter, deviceType } = useGrid();
    useEffect(() => {
        if (typeof document === 'undefined')
            return;
        const root = document.documentElement;
        const columns = gridColumns || 4;
        const gutter = gridGutter || '16px';
        root.style.setProperty('--current-grid-columns', columns.toString());
        root.style.setProperty('--current-grid-gutter', gutter);
        root.style.setProperty('--current-device-type', deviceType);
    }, [gridColumns, gridGutter, deviceType]);
    return _jsx(_Fragment, { children: children });
};
function setCSSVariablesFromTheme(theme) {
    if (typeof document === 'undefined')
        return;
    const root = document.documentElement;
    function setVars(obj, prefix) {
        Object.entries(obj).forEach(([key, value]) => {
            const newPrefix = [...prefix, key];
            if (typeof value === 'object' && value !== null) {
                setVars(value, newPrefix);
            }
            else {
                const cssVar = '--' + newPrefix.join('-').toLowerCase();
                root.style.setProperty(cssVar, String(value));
            }
        });
    }
    setVars(theme, []);
}
export const ThemeProvider = ({ theme, children }) => {
    useEffect(() => {
        setCSSVariablesFromTheme(theme);
    }, [theme]);
    return (_jsx(ThemeContext.Provider, { value: {
            ...theme,
        }, children: _jsx(GridProvider, { children: children }) }));
};
export const useTheme = () => useContext(ThemeContext);
